<h3>APIM Subscriptions</h3>

@if (error) {
  <div class="alert alert-danger" role="alert" style="margin-top: 10px; margin-bottom: 10px;">
    {{ error }}
  </div>
}

<div style="width: 100%;">
  <kendo-grid
    [data]="subscriptions"
    [loading]="loading"
    [scrollable]="'none'"
    [pageable]="false">
    <ng-template kendoGridLoadingTemplate>
      <div class="d-flex justify-content-center align-items-center" style="height: 60px;">
        <div class="spinner-border alfalaval-blue-color" role="status"></div>
      </div>
    </ng-template>
    <kendo-grid-column field="name" title="Name"></kendo-grid-column>
    <kendo-grid-column field="displayName" title="Display Name"></kendo-grid-column>
    <kendo-grid-column field="scope" title="Scope" [width]="140"></kendo-grid-column>
    <kendo-grid-column field="state" title="State" [width]="110"></kendo-grid-column>
    <kendo-grid-column field="ownerId" title="Owner ID" [width]="110"></kendo-grid-column>
    <kendo-grid-column field="createdDate" title="Created Date" [width]="180"></kendo-grid-column>
    <kendo-grid-column field="startDate" title="Start Date" [width]="180"></kendo-grid-column>
    <kendo-grid-column field="expirationDate" title="Expiration Date" [width]="180"></kendo-grid-column>
  </kendo-grid>
</div>
